import { UndoOutlined } from '@ant-design/icons';
import { Button } from '@components/Button/Button';
import { PageTitle } from '@components/common/PageTitle/PageTitle';
import { Input, Spin, Typography } from 'antd';
import dayjs from 'dayjs';
import { useMemo, useState } from 'react';

import { useGetMeQuery } from '@/api/auth/api';
import { useGetActiveTaskQuery } from '@/api/vaccination/task/api';
import { Farm } from '@/pages/TaskTablet/components/farm/Farm';
import { Swiping } from '@/pages/TaskTablet/components/swiping/Swiping';
import { filterByInventoryNumber } from '@/utils/task';

import cl from './styles.module.scss';
import {
  EventProtocol,
  ProtocolIndividual,
} from '@/pages/Vaccination/components/task/types';

const { Text } = Typography;

export const TaskTablet = () => {
  const { data: user } = useGetMeQuery();
  const { data: activeTask, isLoading } = useGetActiveTaskQuery(
    { organizationId: user?.organization?.id || '' },
    { skip: !user?.organization?.id },
  );

  const [inputValue, setInputValue] = useState('');
  const [searchValue, setSearchValue] = useState('');

  const groupsDataByStructureId = useMemo(() => {
    return filterByInventoryNumber(activeTask?.protocols || [], searchValue);
  }, [activeTask, searchValue]);

  const duplicateInventoryNumbers = useMemo(() => {
    const counts = new Map<string, number>();
    (activeTask?.eventProtocols || []).forEach((protocol: any) => {
      protocol.individuals?.forEach((ind: ProtocolIndividual) => {
        if (ind.inventoryNumber) {
          counts.set(ind.inventoryNumber, (counts.get(ind.inventoryNumber) || 0) + 1);
        }
      });
    });

    return new Set(
      Array.from(counts.entries())
        .filter(([, count]) => count > 1)
        .map(([num]) => num),
    );
  }, [activeTask, isLoading]);

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const handleInventoryClick = (value: string) => {
    setInputValue(value);
    setSearchValue(value);
  };

  const handleClear = () => {
    setInputValue('');
    setSearchValue('');
  };

  return (
    <div className={cl.task}>
      <PageTitle
        level={4}
        title={`Наряд фельдшера на ${dayjs(activeTask?.taskDate).format('DD.MM.YYYY')} по
        хозяйству ${user?.organization?.name || ''}`}
        className={cl.title}
      />
      <div className={cl.searchWrap}>
        <div>
          <Input.Search
            className={cl.searchInput}
            allowClear={false}
            placeholder={'Введите инвентарный номер'}
            onSearch={handleSearch}
            onChange={(e) => setInputValue(e.target.value)}
            value={inputValue}
            disabled={activeTask === null}
          />
          <Button
            icon={<UndoOutlined style={{ fontSize: 18, transform: 'rotate(90deg)' }} />}
            type="text"
            action={handleClear}
            disabled={activeTask === null}
          />
        </div>

        <Swiping />
      </div>
      {isLoading ? (
        <Spin className={cl.loading} size="large" />
      ) : (
        <div className={cl.farmsWrap}>
          {groupsDataByStructureId?.map((item) => (
            <Farm
              key={item.structuralDivisionId}
              {...item}
              isTransformData={!!searchValue.trim()}
              duplicateInventoryNumbers={duplicateInventoryNumbers}
              onInventoryClick={handleInventoryClick}
            />
          ))}
          {activeTask === null && (
            <Text style={{ alignSelf: 'center' }} strong>
              На сегодняшний день наряд фельдшера не сформирован
            </Text>
          )}
          {!groupsDataByStructureId.length && searchValue ? (
            <Text style={{ alignSelf: 'center' }} strong>
              На сегодняшний день проведение мероприятия для особи не предусмотрено
            </Text>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};
